const sidescrollerSection = document.querySelector('.sidescroller')
const sidescrollerContainer = document.querySelector('.sidescroller-content-card')
const sidescrollerContent = document.querySelectorAll('.sidescroller-content-card .card')
const buttons = document.querySelectorAll('.sidescroller-tabs button')
const underlayTexts = document.querySelectorAll('.sidescroller-underlay .huge-text')

if (sidescrollerSection && sidescrollerContent.length > 0) {
	const TABLET_BREAKPOINT = 992
	const DESKTOP_BREAKPOINT = 1200
	const cards = Array.from(sidescrollerContent)
	const totalCards = cards.length

	// Create dots container for mobile
	const dotsContainer = document.createElement('div')
	dotsContainer.className = 'sidescroller-dots'
	cards.forEach((_, index) => {
		const dot = document.createElement('button')
		dot.className = `dot${index === 0 ? ' active' : ''}`
		dot.setAttribute('aria-label', `Go to slide ${index + 1}`)
		dotsContainer.appendChild(dot)
	})
	sidescrollerSection.appendChild(dotsContainer)
	const dots = dotsContainer.querySelectorAll('.dot')

	let currentIndex = 0
	let isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT
	let scrollTriggerInstance = null
	let tl = null

	// Set initial button state
	if (buttons.length > 0) {
		buttons[0].classList.add('active')
	}

	// Flag to control snapping behavior
	let allowSnap = true
	const snapIncrement = 1 / (totalCards - 1)
	const numTransitions = totalCards - 1

	// Update active states for dots, buttons, and underlay
	const updateActiveStates = (index) => {
		currentIndex = index
		dots.forEach((dot, i) => {
			dot.classList.toggle('active', i === index)
		})
		buttons.forEach((btn, i) => {
			btn.classList.toggle('active', i === index)
		})
		underlayTexts.forEach((text, i) => {
			text.classList.toggle('active', i === index)
		})
	}

	// Mobile: Show specific card
	const showCard = (index, direction = 0) => {
		if (index < 0 || index >= totalCards) return

		cards.forEach((card, i) => {
			if (i === index) {
				gsap.set(card, { x: 0, opacity: 1 })
			} else {
				gsap.set(card, { x: i < index ? -window.innerWidth : window.innerWidth, opacity: 0 })
			}
		})
		updateActiveStates(index)
	}

	// Mobile: Navigate to card with animation
	const goToCard = (index) => {
		if (index < 0 || index >= totalCards || index === currentIndex) return

		const direction = index > currentIndex ? 1 : -1
		const currentCard = cards[currentIndex]
		const nextCard = cards[index]

		// Set next card initial position
		gsap.set(nextCard, { x: direction * window.innerWidth, opacity: 1 })

		// Animate both cards
		gsap.to(currentCard, {
			x: -direction * window.innerWidth,
			opacity: 0,
			duration: 0.4,
			ease: 'power2.out'
		})
		gsap.to(nextCard, {
			x: 0,
			duration: 0.4,
			ease: 'power2.out'
		})

		updateActiveStates(index)
	}

	// Initialize desktop GSAP ScrollTrigger
	const initDesktop = () => {
		// Kill mobile touch listeners
		sidescrollerSection.removeEventListener('touchstart', handleTouchStart)
		sidescrollerSection.removeEventListener('touchmove', handleTouchMove)
		sidescrollerSection.removeEventListener('touchend', handleTouchEnd)

		// Reset all card positions
		cards.forEach((card, index) => {
			if (index === 0) {
				gsap.set(card, { x: 0, opacity: 1 })
			} else {
				gsap.set(card, { x: window.innerWidth, opacity: 0 })
			}
		})

		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

		tl = gsap.timeline({
			scrollTrigger: {
				trigger: sidescrollerSection,
				start: 'top top',
				end: 'bottom top',
				pin: true,
				scrub: 1,
				snap: {
					snapTo: (progress) => {
						if (!allowSnap) return progress
						return Math.round(progress / snapIncrement) * snapIncrement
					},
					duration: 0.3,
				},
				invalidateOnRefresh: true,
				onUpdate: (self) => {
					const progress = self.progress
					const activeIndex = Math.min(
						Math.floor(progress * numTransitions + 0.5),
						totalCards - 1
					)
					updateActiveStates(activeIndex)
				},
			},
		})

		scrollTriggerInstance = tl.scrollTrigger

		// Animate cards
		cards.forEach((card, index) => {
			if (index > 0) {
				const startProgress = (index - 1) / numTransitions
				const duration = 1 / numTransitions

				tl.to(card, {
					x: 0,
					opacity: 1,
					duration: duration,
					ease: 'none',
				}, startProgress)

				tl.to(cards[index - 1], {
					x: -window.innerWidth,
					opacity: 0,
					duration: duration,
					ease: 'none',
				}, startProgress)
			}
		})

		// Button click handlers for desktop
		buttons.forEach((btn, index) => {
			btn.addEventListener('click', () => {
				if (!isDesktop || !scrollTriggerInstance) return
				const targetProgress = index / numTransitions
				const scrollTo = scrollTriggerInstance.start + (scrollTriggerInstance.end - scrollTriggerInstance.start) * targetProgress
				allowSnap = false
				gsap.to(window, {
					scrollTo: scrollTo,
					duration: 0.5,
					ease: 'power2.inOut',
					onComplete: () => {
						setTimeout(() => {
							allowSnap = true
						}, 350)
					}
				})
			})
		})
	}

	// Mobile touch handling
	let touchStartX = 0
	let touchStartY = 0
	let touchEndX = 0
	let touchEndY = 0
	let isSwiping = false

	const handleTouchStart = (e) => {
		touchStartX = e.touches[0].clientX
		touchStartY = e.touches[0].clientY
		isSwiping = false
	}

	const handleTouchMove = (e) => {
		touchEndX = e.touches[0].clientX
		touchEndY = e.touches[0].clientY

		const diffX = Math.abs(touchEndX - touchStartX)
		const diffY = Math.abs(touchEndY - touchStartY)

		// If horizontal swipe is dominant, prevent vertical scroll
		if (diffX > diffY && diffX > 10) {
			isSwiping = true
			e.preventDefault()
		}
	}

	const handleTouchEnd = () => {
		if (!isSwiping) return

		const diffX = touchStartX - touchEndX
		const threshold = 50

		if (Math.abs(diffX) > threshold) {
			if (diffX > 0 && currentIndex < totalCards - 1) {
				// Swipe left - next
				goToCard(currentIndex + 1)
			} else if (diffX < 0 && currentIndex > 0) {
				// Swipe right - prev
				goToCard(currentIndex - 1)
			}
		}
	}

	// Initialize mobile
	const initMobile = () => {
		// Kill desktop ScrollTrigger
		if (scrollTriggerInstance) {
			scrollTriggerInstance.kill()
			scrollTriggerInstance = null
		}
		if (tl) {
			tl.kill()
			tl = null
		}

		// Unpin section
		gsap.set(sidescrollerSection, { clearProps: 'all' })

		// Reset and show current card
		showCard(currentIndex)

		// Add touch listeners
		sidescrollerSection.addEventListener('touchstart', handleTouchStart, { passive: true })
		sidescrollerSection.addEventListener('touchmove', handleTouchMove, { passive: false })
		sidescrollerSection.addEventListener('touchend', handleTouchEnd, { passive: true })

		// Dot click handlers
		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => {
				if (isDesktop) return
				goToCard(index)
			})
		})
	}

	// Handle resize
	const handleResize = () => {
		const wasDesktop = isDesktop
		isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT

		if (wasDesktop !== isDesktop) {
			if (isDesktop) {
				initDesktop()
			} else {
				initMobile()
			}
		} else if (isDesktop && scrollTriggerInstance) {
			ScrollTrigger.refresh()
		}
	}

	// Initialize
	if (isDesktop) {
		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
		initDesktop()
	} else {
		initMobile()
	}

	// Debounced resize handler
	let resizeTimer
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(handleResize, 250)
	})
}
